import { SxProps, Theme } from "@mui/material";

import { PromptTemplateScope } from "../../types/prompt-template";

export const SCOPE_DISPLAY_NAMES: Record<PromptTemplateScope, string> = {
  [PromptTemplateScope.enlighten_me]: "Enlighten Me",
  [PromptTemplateScope.coaching_hub]: "Coaching Hub"
};

export const TEMPERATURE_MIN = 0;
export const TEMPERATURE_MAX = 1;
export const TEMPERATURE_STEP = 0.01;
export const TABLE_COLUMN_COUNT = 9;

export interface SelectOption {
  value: string;
  label: string;
}

export const CATEGORY_OPTIONS: SelectOption[] = [
  { value: "training", label: "Training" },
  { value: "performance", label: "Performance" },
  { value: "motivation", label: "Motivation" },
  { value: "discovery", label: "Discovery" }
];

export const ABOUT_OPTIONS: SelectOption[] = [
  { value: "individual", label: "Individual" },
  { value: "team", label: "Team" }
];

export const AUDIENCE_OPTIONS: SelectOption[] = [
  { value: "individual", label: "Individual" },
  { value: "team", label: "Team" },
  { value: "manager", label: "Manager" }
];

export const PRIMARY_FUNCTION_OPTIONS: SelectOption[] = [
  { value: "onboarding", label: "Onboarding" },
  { value: "monthly 1:1 prep", label: "Monthly 1:1 Prep" },
  { value: "90 day performance review", label: "90 Day Performance Review" },
  { value: "monday morning manager catch-up", label: "Monday Morning Manager Catch-up" },
  { value: "friday team excellence", label: "Friday Team Excellence" },
  { value: "monthly team insights", label: "Monthly Team Insights" }
];

export const DRAWER_PAPER_SX: SxProps<Theme> = {
  width: { xs: "100%", sm: "50%", md: "40%" },
  maxWidth: "600px",
  p: 3,
  overflow: "auto"
};
